var UserInvited = function () {
  var self = this
  self.name = ko.observable('').extend({ minLength: 2 })
  self.surname = ko.observable('').extend({ minLength: 2 })
  self.email = ko.observable('').extend({ required: true, email: true })
}

function InviteViewModel (invitedType, senderType, numberRecipients) {
  var self = this

  self.sending = ko.observable(false)
  self.messageErrors = ko.observable(null)
  self.customText = ko.observable(null)
  self.allButton = ko.observable(false)
  self.messageSuccess = ko.observable(null)
  self.invitedType = ko.observable(invitedType ? invitedType : 'user')
  self.senderType = ko.observable(senderType ? senderType : 'user')

  self.userInvited = ko.observable(0)
  self.cateringInvited = ko.observable(0)

  self.recipients = ko.observableArray([])

  self.supplierInvited = ko.observable(0)
  self.setAllButton = function () {
    self.allButton(true)

  }
  self.setInvitedType = function (invited) {
    self.invitedType(invited)

  }
  self.setSenderType = function (sender) {
    self.senderType(sender)

  }
  self.getRecipient = function () {
    return new UserInvited()
  }

  self.addRecipient = function () {
    self.recipients.push(self.getRecipient())
  }

  self.delRecipient = function (item) {
    if (self.recipients().length > 1)
      self.recipients.remove(item)

  }

  self.send = function () {
    self.sending(true)
    self.messageErrors(null)
    self.messageSuccess(null)

    var data = {
      recipients: self.recipients,
      invitedType: self.invitedType(),
      senderType: self.senderType()
    }

    return rest('POST', '/api/v2/invites/', data)
        .then(function (response) {
          self.executeResponse(response)
          self.calculateCredit(response)
          self.sending(false)
          return response;
        })
        .catch(function (response) {
          self.sending(false)
          pNotify('Errore nell\'invio degli inviti.', 'error')
        })

  }

  self.sendToCatering = function () {
    self.setInvitedType('catering')
    self.send()
  }

  self.sendToUser = function () {
    self.setInvitedType('user')
    self.send()
  }

  self.sendToSupplier = function () {
    self.setInvitedType('supplier')
    self.send()
  }

  self.getId = function () {
    if (TROVACIGUSTO.catering) {
      return TROVACIGUSTO.catering.id
    }
    if (TROVACIGUSTO.user) {
      return TROVACIGUSTO.user.id
    }
    return null
  }

  //@TODO da rivedere tutta la funzione javascript e server api
  self.sendLeaflet = function (type) {
    self.sending(true)
    self.messageErrors(null)
    self.messageSuccess(null)

    var data = {
      recipients: self.recipients(),
      customText: self.customText()
    }

    rest('POST', '/api/v2/staffs/' + TROVACIGUSTO.user.id + '/' + type + '/leaflet', data)
      .then(function (response) {
        self.sending(false)
        self.messageSuccess(response.success)
        if (response.success) {
          self.recipients([self.getRecipient()])
          self.customText(null)
          self.messageSuccess('Il volantino è stato inviato correttamente.')
          pNotify('Il volantino è stato inviato correttamente.')
        } else {
          var message = []
          for (i in response.data) {
            if (response.data[i].email) {
              message.push(response.data[i].email)
            }
          }
          message = message.length > 0 ? 'I seguenti indirizzi email non sono corretti: ' + message.join(',') : 'Si sono verificati degli errori.'
          self.messageErrors(message)
          pNotify('Errore nell\'invio del volantino.', 'error')

        }
      })
  }

  self.initRecipients = function () {
    self.recipients([])
    if (numberRecipients) {
      for (var i = 0; i < numberRecipients; i++) {
        self.addRecipient()
      }
    } else {
      self.addRecipient()
    }
  }

  self.calculateCredit = function (response) {
    switch (self.invitedType()) {
      case 'user':
        self.userInvited(self.userInvited() + response.data.invitedGuest.length)
        break
      case 'catering':
        self.cateringInvited(self.cateringInvited() + response.data.invitedGuest.length)
        break
      case 'supplier':
        self.supplierInvited(self.supplierInvited() + response.data.invitedGuest.length)
        break
    }

  }

  self.sumInvited = ko.computed(function () {
    return self.userInvited() + self.cateringInvited() + self.supplierInvited()
  })

  self.executeResponse = function (response) {
    self.initRecipients()
    var message = []
    if (response.data.errors) {
      for (var errorMessage in response.data.errors) {
        switch (errorMessage) {
          case 'invite.validators':
            message.push('<h6>I seguenti indirizzi email non sono corretti:</h6>' + response.data.errors[errorMessage].join(', '))
            pNotify('Ci sono alcune email scritte in modo non corretto', 'warning')
            break
          case 'invite.user-registration':
            message.push('<h6>I seguenti indirizzi email non sono stati invitati in modo corretto:</h6>' + response.data.errors[errorMessage].join(', '))
            pNotify('Alcune email non sono state invitate in modo corretto', 'warning')
            break
          case 'invite.count-invite':
            message.push('<h6>Hai gia invitato più volte i seguenti indirizzi email:</h6>' + response.data.errors[errorMessage].join(', '))
            pNotify('Hai gia invitato più volte alcuni indirizzi email', 'warning')
            break
          default:
            pNotify('Errore nell\'invio degli inviti.', 'error')
            break
        }
      }
      self.messageErrors(message.join('<br/>'))
    }
    message = []

    if (response.data.invitedExisting.length > 0) {
      message.push('<h6>Queste email sono già iscritte a TrovaciGusto:</h6>' + response.data.invitedExisting.join(', '))
    }

    if (response.data.invitedExistingNew.length > 0) {
      message.push('<h6>Attenzione, queste email sono state già invitate:</h6> l\'Utente/Attività cui si riferisce l\'indirizzo email ' + response.data.invitedExistingNew.join(', ') + ' è stato già invitato da altri su TrovaciGusto e il suo iter di iscrizione è in corso, pertanto non apparirà nell\'elenco degli Utenti/Attività da te invitati. In ogni caso, la tua email di invito gli è stata spedita e l\'Utente/Attività potrà decidere di utilizzare il tuo codice invito per completare la propria iscrizione, e se ciò accadrà ti sarà comunicato via email e troverai l\'Utente/Attività nell\'elenco sopra citato.')
    }

    if (response.data.invitedGuest.length > 0) {
      message.push('<h6>Queste email sono state correttamente invitate:</h6>' + response.data.invitedGuest.join(', '))
    }
    self.messageSuccess(message.join('<br/>'))

  }

  self.initRecipients()
}
